import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch, apiFetch } from '../../modules/utility';

const apiBase = 'notification';

const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			forceEmptySet: true,
			dispatch,
			callback,
		});
	};
};

const get = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	const notificationId = ownProps.notificationId
		? ownProps.notificationId
		: _.get(ownProps, ['match', 'params', 'notificationId']);
	const notification = _.get(state.maps, ['notification', notificationId]);

	let notifications = undefined;
	if (state.lists.notificationIds) {
		notifications = _.map(state.lists.notificationIds, (id) => state.maps.notification[id]);
	}

	return {
		userMap: state.maps.user,
		notification,
		notifications,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getNotification: get,
			searchNotifications: search,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
